import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';

const FixedButton = ({ classes, ...props }) => (
  <div className={classes.wrapper}>
    <Button className={classes.button} {...props} />
  </div>
);

FixedButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

FixedButton.defaultProps = {
  classes: {},
};

export default FixedButton;
